import { render, staticRenderFns } from "./liveCenter.vue?vue&type=template&id=12b686b5&scoped=true&"
import script from "./liveCenter.vue?vue&type=script&lang=js&"
export * from "./liveCenter.vue?vue&type=script&lang=js&"
import style0 from "./liveCenter.vue?vue&type=style&index=0&id=12b686b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b686b5",
  null
  
)

export default component.exports